import { render, staticRenderFns } from "./FooterConfig.vue?vue&type=template&id=aff86136&scoped=true"
import script from "./FooterConfig.vue?vue&type=script&lang=js"
export * from "./FooterConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff86136",
  null
  
)

export default component.exports